import { ViewSGBSApplicationFormData } from "../data/ViewSGBSApplicationForm.data";

export const setFieldParameter = (apiResponse) => { 
    ViewSGBSApplicationFormData.initialState.companyName = apiResponse?.companyName || null; 
    ViewSGBSApplicationFormData.initialState.companyUEN = apiResponse?.companyUEN || null;
    ViewSGBSApplicationFormData.initialState.typeOfCompany = apiResponse?.typeOfCompanyId || null;
    ViewSGBSApplicationFormData.initialState.mainContactPerson = Number(apiResponse?.mainContactPersonId) || null;
    ViewSGBSApplicationFormData.initialState.mainContactPhoneCountryCode = apiResponse?.contactNumberCountryId|| null;
    ViewSGBSApplicationFormData.initialState.mainContactPhone = apiResponse?.mainContactPhone || null;
    ViewSGBSApplicationFormData.initialState.mainContactEmailAddress = apiResponse?.mainContactEmailAddress || null;
    ViewSGBSApplicationFormData.initialState.serviceCategory = Number(apiResponse?.sgbsServiceCategoryId) || null;
  };
